import Skeleton from '@material-ui/lab/Skeleton/Skeleton'

import useStyles from './styles/CheckStatusRowSkeleton.styles'

interface CheckStatusRowSkeletonProps {}

const CheckStatusRowSkeleton: React.FC<CheckStatusRowSkeletonProps> = ({}) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      {Array(4)
        .fill(null)
        .map(() => (
          <div>
            <Skeleton animation="wave" className={classes.skeleton} />
          </div>
        ))}
    </div>
  )
}
export default CheckStatusRowSkeleton
